import React from "react";
import SEO from "../components/SEO";

const css = `
:root {
 --blue:    #2563EB;
 --blue-d:  #1D4ED8;
 --blue-l:  #EFF6FF;
 --dark:    #0A1628;
 --mid:     #1E3A5F;
 --gray:    #475569;
 --lgray:   #64748B;
 --xlgray:  #94A3B8;
 --border:  #E2E8F0;
 --off:     #F8FAFC;
 --white:   #FFFFFF;
}
.privacy-page *,.privacy-page *::before,.privacy-page *::after { box-sizing:border-box; margin:0; padding:0 }
.privacy-page { font-family:'Inter',sans-serif; background:var(--off); color:var(--dark); line-height:1.7; font-size:16px; -webkit-font-smoothing:antialiased; }
.privacy-page .site-header { border-bottom: 1px solid var(--border); padding: 18px 24px; position: sticky; top:0; z-index:50; backdrop-filter: blur(12px); background: rgba(255,255,255,.96); }
.privacy-page .header-inner { max-width: 880px; margin:0 auto; display:flex; align-items:center; justify-content:space-between; gap:16px; }
.privacy-page .brand img { height:36px; display:block }
.privacy-page .back-link { font-size:13px; font-weight:600; color:var(--gray); text-decoration:none; display:flex; align-items:center; gap:6px; transition: color .15s; }
.privacy-page .back-link:hover { color:var(--blue) }
.privacy-page .back-link svg { width:14px; height:14px }
.privacy-page .doc-hero { background: var(--off); border-bottom: 1px solid var(--border); padding: 160px 24px 40px; }
.privacy-page .doc-hero-inner { max-width:880px; margin:0 auto }
.privacy-page .doc-eyebrow { display:inline-block; font-size:11px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:var(--blue); margin-bottom:14px; }
.privacy-page .doc-hero h1 { font-size:clamp(28px, 4vw, 40px); font-weight:800; letter-spacing:-.5px; line-height:1.15; color:var(--dark); margin-bottom:14px; }
.privacy-page .doc-meta { display:flex; gap:24px; flex-wrap:wrap; font-size:13.5px; color:var(--lgray); }
.privacy-page .doc-meta strong { color:var(--dark); font-weight:600 }
.privacy-page .doc-body { max-width: 720px; margin: 0 auto; padding: 56px 24px 80px; }
.privacy-page .doc-body p, .privacy-page .doc-body li { font-size: 15.5px; color: var(--gray); line-height: 1.75; }
.privacy-page .doc-body p { margin-bottom: 18px }
.privacy-page .doc-body strong { color: var(--dark); font-weight:600 }
.privacy-page .doc-body h2 { font-size: 22px; font-weight: 700; color: var(--dark); letter-spacing: -.2px; margin: 44px 0 16px; padding-bottom: 12px; border-bottom: 1px solid var(--border); scroll-margin-top: 90px; }
.privacy-page .doc-body h2:first-child { margin-top: 0 }
.privacy-page .doc-body h3 { font-size: 17px; font-weight: 700; color: var(--dark); margin: 28px 0 10px; }
.privacy-page .doc-body ul, .privacy-page .doc-body ol { margin: 0 0 18px 22px; padding: 0; }
.privacy-page .doc-body li { margin-bottom: 8px }
.privacy-page .intro-block { background: var(--blue-l); border-left: 3px solid var(--blue); padding: 18px 22px; border-radius: 0 8px 8px 0; margin-bottom: 36px; }
.privacy-page .intro-block p { margin:0; color:var(--mid); font-size:15px }
.privacy-page .intro-block p:not(:last-child) { margin-bottom:10px }
.privacy-page a.inline-link { color:var(--blue); text-decoration:underline; font-weight:500 }
.privacy-page a.inline-link:hover { color:var(--blue-d) }
.privacy-page footer.doc-footer { background: var(--dark); padding: 36px 24px 24px; }
.privacy-page .foot-inner { max-width: 880px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; margin-bottom: 24px; }
.privacy-page .foot-brand { display:flex; align-items:center; gap:10px; text-decoration:none }
.privacy-page .foot-brand img { height: 26px; filter: brightness(0) invert(1); opacity: .75; }
.privacy-page .foot-brand span { font-size:13px; color:rgba(255,255,255,.4) }
.privacy-page .foot-links { display:flex; gap:22px; flex-wrap:wrap }
.privacy-page .foot-links a { font-size:13px; color:rgba(255,255,255,.55); text-decoration:none; transition: color .15s; }
.privacy-page .foot-links a:hover { color:#fff }
.privacy-page .foot-bot { max-width: 880px; margin: 0 auto; border-top: 1px solid rgba(255,255,255,.08); padding-top: 18px; text-align: center; font-size: 12px; color: rgba(255,255,255,.4); }
@media(max-width:640px) {
 .privacy-page .site-header { padding: 14px 18px }
 .privacy-page .brand img { height:28px }
 .privacy-page .doc-hero { padding: 130px 20px 28px }
 .privacy-page .doc-body { padding: 36px 20px 60px }
 .privacy-page .doc-body p, .privacy-page .doc-body li { font-size: 15px }
 .privacy-page .doc-body h2 { font-size: 19px; margin-top: 36px }
 .privacy-page .doc-body h3 { font-size: 16px }
 .privacy-page .foot-inner { flex-direction:column; align-items:flex-start; gap:14px }
 .privacy-page .foot-links { gap: 16px }
}
`;

const Privacy = () => {
  return (
    <div className="privacy-page">
      <SEO
        title="Privacy Policy"
        description="SmileReveal Privacy Policy — how we collect, use, and protect information."
      />
      <style>{css}</style>

      <section className="doc-hero">
        <div className="doc-hero-inner">
          <span className="doc-eyebrow">Legal</span>
          <h1>Privacy Policy</h1>
          <div className="doc-meta">
            <span><strong>Effective Date:</strong> May 5, 2026</span>
            <span><strong>Last Updated:</strong> May 5, 2026</span>
          </div>
        </div>
      </section>

      <main className="doc-body">
        <div className="intro-block">
          <p>SmileReveal, Inc. ("SmileReveal," "we," "our," or "us") provides a software-as-a-service platform designed to help dental practices visualize potential cosmetic outcomes.</p>
          <p>This Privacy Policy explains how we collect, use, disclose, and protect information when you visit our website or use the SmileReveal platform (collectively, the "Services").</p>
        </div>

        <h2 id="scope">1. Scope of This Policy</h2>
        <p>This Privacy Policy applies to:</p>
        <ul>
          <li>Visitors to <a className="inline-link" href="https://theimplantengine.com">https://theimplantengine.com</a> and related marketing pages</li>
          <li>Authorized users of the SmileReveal application</li>
        </ul>
        <p>This policy does <strong>not</strong> replace or supersede any Business Associate Agreement ("BAA") executed between SmileReveal and a dental practice. Where PHI is involved, the BAA governs.</p>

        <h2 id="information-we-collect">2. Information We Collect</h2>

        <h3>2.1 Website Information</h3>
        <p>When you visit our website, we may collect:</p>
        <ul>
          <li>Name, email address, company name (via contact or demo forms)</li>
          <li>IP address, browser type, device information</li>
          <li>Usage data through cookies or analytics tools</li>
        </ul>

        <h3>2.2 Application Information</h3>
        <p>When practices use SmileReveal, we may process:</p>
        <ul>
          <li>Facial images uploaded by the practice</li>
          <li>Generated visual previews and animations</li>
          <li>Practice-level case references</li>
          <li>User account and access information</li>
        </ul>
        <p>SmileReveal is designed to minimize the collection of direct patient identifiers. Practices are instructed not to upload unnecessary PHI such as patient names, dates of birth, or contact information.</p>

        <h2 id="phi">3. Protected Health Information (PHI)</h2>
        <p>To the extent SmileReveal processes Protected Health Information ("PHI"), it does so as a <strong>Business Associate</strong> under HIPAA pursuant to a written BAA with the applicable dental practice. PHI is:</p>
        <ul>
          <li>Used solely to provide the Services</li>
          <li>Not sold, marketed, or shared for advertising</li>
          <li>Not used to train or improve AI or machine learning models</li>
        </ul>

        <h2 id="how-we-use">4. How We Use Information</h2>
        <p>We use information to:</p>
        <ul>
          <li>Provide, operate, and support the Services</li>
          <li>Maintain platform security and reliability</li>
          <li>Respond to inquiries and support requests</li>
          <li>Comply with legal and regulatory obligations</li>
        </ul>

        <h2 id="security">5. Data Protection and Security</h2>
        <p>We implement administrative, technical, and physical safeguards designed to protect information, including:</p>
        <ul>
          <li>Encryption in transit and at rest</li>
          <li>Role-based access controls</li>
          <li>Practice-level tenant isolation</li>
          <li>Audit logging</li>
        </ul>
        <p>SmileReveal is hosted on Google Cloud under an executed HIPAA Business Associate Agreement.</p>

        <h2 id="retention">6. Data Retention</h2>
        <ul>
          <li>Website data is retained as necessary for business and legal purposes</li>
          <li>Application data is retained according to contractual terms with practices, with default automated deletion policies</li>
        </ul>

        <h2 id="sharing">7. Sharing and Disclosure</h2>
        <p>We may share information:</p>
        <ul>
          <li>With service providers acting on our behalf under contractual safeguards</li>
          <li>As required by law</li>
          <li>With the applicable dental practice</li>
        </ul>
        <p>We do not sell personal information.</p>

        <h2 id="rights">8. Your Rights</h2>
        <p>Depending on your role and location, you may have rights to access, correct, or delete information. Requests related to PHI must be directed to the dental practice.</p>

        <h2 id="updates">9. Updates to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Material changes will be posted on our website.</p>
      </main>

      <footer className="doc-footer">
        <div className="foot-inner">
          <a href="/" className="foot-brand">
            <img
              src="https://assets.cdn.filesafe.space/tKloRW99HBqpfyHkP2PZ/media/69b51709eba487b1413f9072.png"
              alt="SmileReveal"
            />
            <span>Exclusive offer for TIE partner practices</span>
          </a>
          <div className="foot-links">
            <a href="/">About SmileReveal</a>
            <a href="/hipaa">HIPAA Compliance</a>
            <a href="mailto:sales@smilereveal.io">Contact</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/tos">Terms of Service</a>
          </div>
        </div>
        <div className="foot-bot">© 2026 SmileReveal. All rights reserved. Offer exclusively available through The Implant Engine partner program.</div>
      </footer>
    </div>
  );
};

export default Privacy;
